<template>
    <div v-if="getShowErrorMessage">
        <div v-if="task_id != old_task_id">{{refreshView()}}</div>
        <v-card class="chapter-card border-radius-md shadow-none card-border-style">
            <v-card-title>
                Error report
                <v-icon class="btn-close"
                    @click="$store.commit('setShowErrorMessage',false)"
                >
                close</v-icon> 
            </v-card-title>
            <v-card-text>       
                <p></p>         
                <v-textarea
                    v-model="dataMessage"
                    :counter="counter"
                    filled
                    flat
                    label="Write 3-500 characters description of error:"
                    outlined
                    :rows="5"                    
                ></v-textarea>
                
            </v-card-text>
            <v-card-actions>
                <v-layout justify-end>
                    <v-icon class="color-green" large @click="sendErrorMessage()">done</v-icon>
                </v-layout>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from '../../axios-auth'

export default {
    data() {
        return {
            dataMessage: '',
            counter: 0,
            old_task_id: 0
        }
    },
    props: ['task_id'],
    computed: 
        mapGetters([
                    'getShowErrorMessage'
                ])
    ,
    mounted() {
        this.dataMessage = ''
        this.old_task_id = this.task_id
    }, 
    methods: {
        sendErrorMessage() {
            if (this.dataMessage.length < 3) return
            const data = {
                task_id: this.task_id,
                description: this.dataMessage.substring(0, Math.min(500, this.dataMessage.length))
            }
            axios.post('/write-error-report', data, this.$store.getters.getAxiosConfig)
                .then(() => {
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })   
            this.$store.commit('setShowErrorMessage',false)
        },
        refreshView() {
            this.old_task_id = this.task_id
            this.dataMessage = ''
        }
    }
}
</script>

